// import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavBigComponent } from './../layout/nav-big/nav-big.component';
import { LogoComponent } from './../layout/logo/logo.component';
import { NavSmallComponent } from './../layout/nav-small/nav-small.component';
import { ContentLayoutComponent } from './../layout/content-layout/content-layout.component';
import { DialogBoxComponent } from 'src/app/shared/components/dialog-box/dialog-box.component';
import { ErrorComponent } from './../shared/components/error/error.component';
import { LoaderComponent } from './../shared/components/loader/loader.component';
import { HistoryTableComponent } from './../shared/components/history-table/history-table.component';
import { AlphanumericDirective } from './../shared/directives/alphanumeric.directive';
import { OnlyNumbersDirective } from './../shared/directives/only-numbers.directive';

@NgModule({
    declarations: [
        NavBigComponent,
        LogoComponent,
        NavSmallComponent,
        ContentLayoutComponent,
        DialogBoxComponent,
        ErrorComponent,
        LoaderComponent,
        HistoryTableComponent,
        AlphanumericDirective,
        OnlyNumbersDirective,
    ],
    imports: [
        // BrowserModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        BsDatepickerModule,
        NgbModule,
        // DatepickerModule.forRoot()
    ],
    providers: [],
    exports: [
        CommonModule,
        NavBigComponent,
        LogoComponent,
        NavSmallComponent,
        ContentLayoutComponent,
        DialogBoxComponent,
        ErrorComponent,
        LoaderComponent,
        HistoryTableComponent,
        AlphanumericDirective,
        OnlyNumbersDirective
    ]
})
export class SharedModule { }
